import axios from 'shared/lib/axios';
import {
  BaseProductSet,
  DraftProductPurchaseCartItem,
  ProductCart,
  ProductPurchaseCartItem,
  ProductRentalCartItem,
  ProductSet,
  ProductSetInventory,
  ProductSetOrder,
  ProductSetPurchaseGroup,
  ProductSetRentalGroup
} from 'shared/types';

export function getProductSets() {
  return axios.get<ProductSet[]>('/v1/product_sets');
}

export function getBaseProductSets() {
  return axios.get<BaseProductSet[]>('/v1/base_product_sets');
}

export function getProductCart() {
  return axios.get<ProductCart>('/v1/product_cart');
}

export function removeProductRentalCartItem(productRentalCartItem: ProductRentalCartItem) {
  return axios.delete<ProductCart>(`/v1/product_rental_cart_items/${productRentalCartItem.id}`);
}

export function addProductPurchaseCartItem(productPurchaseCartItem: DraftProductPurchaseCartItem) {
  return axios.post<ProductCart>('/v1/product_purchase_cart_items', {
    product_purchase_cart_item: productPurchaseCartItem
  });
}

export function removeProductPurchaseCartItem(productPurchaseCartItem: ProductPurchaseCartItem) {
  return axios.delete<ProductCart>(`/v1/product_purchase_cart_items/${productPurchaseCartItem.id}`);
}

export function updateProductPurchaseCartItem(productPurchaseCartItem: ProductPurchaseCartItem) {
  return axios.put<ProductCart>(
    `/v1/product_purchase_cart_items/${productPurchaseCartItem.id}`,
    productPurchaseCartItem
  );
}

export function checkoutProductCart() {
  return axios.post('/v1/product_cart/checkout');
}

export function getProductSetOrders() {
  return axios.get<ProductSetOrder[]>('/v1/product_set_orders');
}

export function getProductSetInventory() {
  return axios.get<ProductSetInventory[]>('/v1/product_set_inventory');
}

export function createProductSetRentalGroupFeedback(productSetRentalGroupId: number, liked: boolean, message?: string) {
  return axios.post<ProductSetRentalGroup>(`/v1/product_set_rental_groups/${productSetRentalGroupId}/feedback`, {
    liked,
    message
  });
}

export function createProductSetPurchaseGroupFeedback(
  productSetPurchaseGroupId: number,
  liked: boolean,
  message?: string
) {
  return axios.post<ProductSetPurchaseGroup>(`/v1/product_set_purchase_groups/${productSetPurchaseGroupId}/feedback`, {
    liked,
    message
  });
}

export function createFurniturePurchaseInquiry(productSetId: number) {
  return axios.post('/v1/furniture_purchase_inquiries', { product_set_id: productSetId });
}
